import domain from '../domain';

const onHotspotPointClick = domain.event<{ id: string; index: number }>();

export default onHotspotPointClick;
